import once from 'lodash/once';
import { createContext, Dispatch, SetStateAction } from 'react';

/** Represents the create function. */
export type CreateFn<TItem> = () => Promise<TItem | undefined>;

/** Represents the create item context. */
export const getCreateItemContext = once(<TItem>() =>
  createContext<{
    /** The search term. */
    readonly searchTerm: string;
    /** The callback for whenever the item should be created. */
    readonly setCreate: Dispatch<SetStateAction<CreateFn<TItem> | undefined>>;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  }>(undefined!),
);
